import React, { useState, useRef } from 'react';
import StatusBar from '@dataGrid/components/StatusBar';
import DataGrid from '@dataGrid';
import HolidayGridHeader from './HolidayGridHeader';
import { getCustomerHolidayGridRowId } from '../../../CustomerManagement/EditCustomer/components/Holidays/utils';

const constructStatusBar = (holidayList) => {
  return [
    {
      label: `${holidayList.length} Holidays`
    }
  ];
};

const HolidayDataGrid = ({
  classes,
  gridConfig,
  openAddEditHolidayPanel,
  gridData,
  selectedRowData,
  showHolidayForm,
  runCommand,
  userAccessibleTerminals = [],
  countryList = [],
  isEditCustomerDialog = false
}) => {
  const [quickFilterText, setQuickFilterText] = useState('');
  const gridApi = useRef(null);

  const updateQuickFilterText = (value) => {
    setQuickFilterText(value);
  };

  const onGridReady = ({ api }) => {
    gridApi.current = api;
    gridApi.current.runCommand = runCommand;
  };

  const onRowDataUpdated = () => {
    if (selectedRowData.length && gridApi?.current) {
      gridApi.current.forEachNode((node) => {
        if (selectedRowData.includes(node.data.holidayId)) {
          gridApi.current.ensureIndexVisible(node.rowIndex);
          node.setSelected(true);
        }
      });
    }
  };

  return (
    <div className={classes.moduleContainer}>
      <div className={`${classes.gridContainer} ${classes.holidayGridContainer}`}>
        <HolidayGridHeader
          updateQuickFilterText={updateQuickFilterText}
          classes={classes}
          gridApi={gridApi.current}
          openAddEditHolidayPanel={openAddEditHolidayPanel}
          isEditCustomerDialog={isEditCustomerDialog}
        />
        <div className={`${classes.dataGrid} ${classes.holidayGrid}`}>
          <DataGrid
            defaultColDef={gridConfig.config.defaultColDef}
            columnDefs={gridConfig.config.columns}
            config={gridConfig.config}
            enableFilter={gridConfig.config.enableFilter}
            enableSorting={gridConfig.config.enableSorting}
            rowSelection={gridConfig.config.rowSelection}
            rowData={gridData}
            onGridReady={onGridReady}
            suppressRowClickSelection={showHolidayForm}
            quickFilterText={quickFilterText}
            context={{
              userAccessibleTerminals,
              countryList
            }}
            accentedSort
            onRowDataUpdated={onRowDataUpdated}
            panelLabel={(filteredData) => (
              <StatusBar data={constructStatusBar(filteredData)} customClass={classes.statusBar} />
            )}
            getRowId={(params) =>
              isEditCustomerDialog
                ? getCustomerHolidayGridRowId(params.data)
                : params.data.holidayId
            }
          />
        </div>
      </div>
    </div>
  );
};

export default HolidayDataGrid;
